__turbopack_context__.v({
  "content": "page-module__LVwdfa__content",
  "header": "page-module__LVwdfa__header",
  "infoCard": "page-module__LVwdfa__infoCard",
  "link": "page-module__LVwdfa__link",
  "metaIcon": "page-module__LVwdfa__metaIcon",
  "paymentInfo": "page-module__LVwdfa__paymentInfo",
  "paymentMethod": "page-module__LVwdfa__paymentMethod",
  "paymentMethodsList": "page-module__LVwdfa__paymentMethodsList",
  "processSteps": "page-module__LVwdfa__processSteps",
  "pulse": "page-module__LVwdfa__pulse",
  "step": "page-module__LVwdfa__step",
  "stepContent": "page-module__LVwdfa__stepContent",
  "stepNumber": "page-module__LVwdfa__stepNumber",
  "subheading": "page-module__LVwdfa__subheading",
  "supportedCards": "page-module__LVwdfa__supportedCards",
  "supportedCryptos": "page-module__LVwdfa__supportedCryptos",
});
